import { render, staticRenderFns } from "./assignInfo.vue?vue&type=template&id=8dbfe758&scoped=true"
import script from "./assignInfo.vue?vue&type=script&lang=js"
export * from "./assignInfo.vue?vue&type=script&lang=js"
import style0 from "./assignInfo.vue?vue&type=style&index=0&id=8dbfe758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbfe758",
  null
  
)

export default component.exports